export default "__VITE_ASSET__6mK_WUP___"